const GooglePaySvg = ({
  height = 40,
  width = 28,
  viewBox = '0 0 40 28',
  className,
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <rect x="0.5" y="0.5" width="39" height="27" rx="5.5" fill="white" stroke="#D9D9D9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.4253 16.7058H31.4458L33.1138 12.4314H34.2856L30.6821 20.9998H29.5698L30.9097 18.0027L28.5444 12.4314H29.7173L31.4253 16.7058ZM25.7847 12.2371C26.5816 12.2371 27.2112 12.4595 27.6733 12.8963C28.1356 13.3333 28.3638 13.9445 28.3638 14.7146V18.3845H27.3325V17.5593H27.2856C26.8368 18.2391 26.2469 18.5789 25.5034 18.5789C24.8737 18.5789 24.3376 18.3844 23.9155 17.9959C23.5003 17.6351 23.2664 17.1007 23.2798 16.5388C23.2798 15.9215 23.5069 15.4358 23.9556 15.0681C24.4044 14.7004 25.008 14.5203 25.7583 14.5203C26.4012 14.5203 26.9241 14.6448 27.3394 14.8806V14.6238C27.3393 14.2424 27.1782 13.8813 26.897 13.6316C26.6091 13.3681 26.2405 13.2226 25.8589 13.2224C25.256 13.2224 24.7795 13.4862 24.4312 14.0134L23.48 13.3963C23.9891 12.6262 24.7598 12.2371 25.7847 12.2371ZM20.6733 9.68435C21.3631 9.67047 22.033 9.94093 22.522 10.4402C23.5 11.3838 23.5608 12.9731 22.6431 13.9929L22.522 14.1179C22.0196 14.6103 21.4034 14.8601 20.6733 14.8601H18.8911V18.3845H17.813V9.68435H20.6733ZM25.9263 15.4217C25.4908 15.4217 25.1215 15.5327 24.8267 15.7478C24.5386 15.9629 24.3911 16.2343 24.3911 16.5603C24.3913 16.8514 24.5257 17.1214 24.7466 17.2879C24.9878 17.4821 25.283 17.5868 25.5845 17.5799C26.0398 17.5797 26.4749 17.3922 26.7964 17.0593C27.1514 16.7126 27.3324 16.3034 27.3325 15.8318C26.9976 15.5544 26.529 15.4148 25.9263 15.4217ZM18.8921 13.7918H20.7007C21.1027 13.8056 21.4914 13.6389 21.7661 13.3406C22.3287 12.7371 22.3153 11.7662 21.7329 11.1834C21.4582 10.9059 21.0893 10.7527 20.7007 10.7527H18.8921V13.7918Z"
        fill="#3C4043"
      />
      <path
        d="M15.168 14.0969C15.168 13.757 15.1412 13.417 15.0876 13.084H10.5391V15.0058H13.1449C13.0378 15.6233 12.6894 16.1783 12.1803 16.5252V17.774H13.7344C14.6455 16.9068 15.168 15.6233 15.168 14.0969Z"
        fill="#4285F4"
      />
      <path
        d="M10.5393 18.9812C11.8389 18.9812 12.9376 18.5372 13.7347 17.774L12.1806 16.5252C11.7451 16.8305 11.1891 17.0039 10.5393 17.0039C9.27994 17.0039 8.21482 16.1228 7.83298 14.9434H6.23193V16.2338C7.0492 17.9197 8.71723 18.9812 10.5393 18.9812Z"
        fill="#34A853"
      />
      <path
        d="M7.83323 14.9432C7.63223 14.3258 7.63223 13.6528 7.83323 13.0284V11.7449H6.23193C5.54183 13.1533 5.54183 14.8184 6.23193 16.2267L7.83323 14.9432Z"
        fill="#FBBC04"
      />
      <path
        d="M10.5393 10.9678C11.2293 10.954 11.8925 11.2245 12.3882 11.7171L13.7682 10.2879C12.8907 9.4415 11.7384 8.97666 10.5393 8.99054C8.71723 8.99054 7.0492 10.059 6.23193 11.7449L7.83298 13.0353C8.21482 11.8489 9.27994 10.9678 10.5393 10.9678Z"
        fill="#EA4335"
      />
    </svg>
  );
};
export default GooglePaySvg;
